module.exports = __webpack_public_path__ + "img/logo.2e47ccfa.svg";